import { usePage } from '@inertiajs/react'
import type { SharedProps } from '@/types'
import { useAccountPath } from '@/lib/useAccountPath'

export default function PlanBanner() {
  const { plan } = usePage<{ props: SharedProps }>().props as unknown as SharedProps
  const ap = useAccountPath()
  if (!plan) return null

  // Complimentary access granted by staff — suppress trial/expiry nags.
  if (plan.comped) return null

  if (plan.read_only) {
    return (
      <div role="alert" className="alert alert-soft alert-warning rounded-none border-x-0 border-t-0">
        <span className="iconify lucide--lock size-5" />
        <div className="flex-1">
          <strong>{plan.plan === 'trialing' ? 'Your trial has ended.' : 'Your plan is inactive.'}</strong>
          <span className="ms-2 text-sm">Your data is preserved. Reactivate to keep creating surveys.</span>
        </div>
        <a href={ap('/billing/expired')} className="btn btn-warning btn-sm">Reactivate</a>
      </div>
    )
  }

  if (plan.status === 'past_due') {
    return (
      <div role="alert" className="alert alert-soft alert-error rounded-none border-x-0 border-t-0">
        <span className="iconify lucide--credit-card size-5" />
        <div className="flex-1 text-sm">
          <strong>Payment failed.</strong> We're retrying — please update your card to avoid losing access.
        </div>
        <a href={ap('/settings/billing')} className="btn btn-error btn-sm">Update card</a>
      </div>
    )
  }

  if (plan.status === 'trialing' && typeof plan.trial_days_remaining === 'number') {
    const days = plan.trial_days_remaining
    if (days <= 7) {
      return (
        <div role="alert" className="alert alert-soft alert-info rounded-none border-x-0 border-t-0">
          <span className="iconify lucide--clock size-5" />
          <div className="flex-1 text-sm">
            {days === 0
              ? <span><strong>Your trial ends today.</strong> Add a payment method to keep going.</span>
              : <span><strong>{days} {days === 1 ? 'day' : 'days'} left in your trial.</strong> Add a payment method to keep using ImpactCheck.</span>
            }
          </div>
          <a href={ap('/settings/billing')} className="btn btn-info btn-sm">View plan</a>
        </div>
      )
    }
  }

  return null
}
